/**
 * Actions for Units module
 */
import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function getUnits(payload) {
  return { type: actionTypes.GET_UNITS, payload };
}
export function getUnitsSuccess(paylaod) {
  const byId = keyBy(paylaod, (course) => course.unit_id);
  return { type: actionTypes.GET_UNITS_SUCCESS, payload: { byId } };
}
